import { render, staticRenderFns } from "./exp_pres_M.vue?vue&type=template&id=2fb085ab&scoped=true"
import script from "./exp_pres_M.vue?vue&type=script&lang=js"
export * from "./exp_pres_M.vue?vue&type=script&lang=js"
import style0 from "./exp_pres_M.vue?vue&type=style&index=0&id=2fb085ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb085ab",
  null
  
)

export default component.exports